// extracted by mini-css-extract-plugin
module.exports = {"overview":"DashboardCustomer_overview__3ZhmS","overviewGraph":"DashboardCustomer_overviewGraph__3gANa","overviewStats":"DashboardCustomer_overviewStats__1_rTO"};